import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyButtonComponent } from './buy-button.component';
import { createCustomElement } from '@angular/elements';
import { GuaranteeSealModule } from '../guarantee-seal/guarantee-seal.module';
import { OrderSummaryModule } from '../order-summary/order-summary.module';
import { ProductListMiniModule } from '../product-list-mini/product-list-mini.module';
import { DirectivesModule } from '../../directives/directives.module';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [BuyButtonComponent],
  imports: [
    CommonModule,
    GuaranteeSealModule,
    OrderSummaryModule,
    ProductListMiniModule,
    DirectivesModule,
    DialogModule,
  ],
  exports: [BuyButtonComponent],
})
export class BuyButtonModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(BuyButtonComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-buy-button', customComponent);
  }
}
